import { gql } from 'graphql-request'

export const QueryBlockCta = gql`
  fragment FragmentBlockCta on BlockCtaModelRecord {
          __typename
          id
          title
          text {
            value
          }
          action {
            ...FragmentNavigationItem
          }
          secondaryAction {
            ...FragmentNavigationItem
          }
          anchor
          theme
        }
`
export const BlockCta = {
  __typename: 'BlockCta',
  fragmentName: 'FragmentBlockCta',
  fragmentQuery: QueryBlockCta,
  fragments: ['FragmentNavigationItem']
}
